import { SupportedToken } from "./types";

export const mapSupportedTokensWithBalancesInitialValues = (
  supportedTokens: SupportedToken[]
) => supportedTokens.map((token) => ({ ...token, balance: "0" }));
